import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let routes = [
  {
    path: "/newgoods",
    name: "newgoods",
    component: resolve => require(["@/components/newgoods/newgoods"], resolve)
  },
  {
    path: "/hotsearch",
    name: "hotsearch",
    component: resolve =>
      require(["@/components/hotsearch/hotsearch"], resolve)
  },
  {
    path: "/brand",
    name: "brand",
    component: resolve =>
      require(["@/components/recommendbrand/brand"], resolve)
  },
  {
    path: "/navigation",
    name: "navigation",
    component: resolve =>
      require(["@/components/storenavigation/navigation"], resolve)
  },
  {
    path: "/wetchat",
    name: "wetchat",
    component: resolve =>
      require(["@/components/storenavigation/wetchat"], resolve)
  },
  {
    path: "/seasongoods",
    name: "seasongoods",
    component: resolve =>
      require(["@/components/seasongoods/seasongoods"], resolve)
  },
  {
    path: "/newtowel",
    name: "newtowel",
    component: resolve =>
      require(["@/components/seasongoods/newtowel"], resolve)
  },
  {
    path: "/winprize",
    name: "winprize",
    component: resolve => require(["@/components/prize/winprize"], resolve)
  },
  {
    path: "/goodsupplier",
    name: "goodsupplier",
    component: resolve =>
      require(["@/components/prize/goodsupplier"], resolve)
  },
  {
    path: "/topsupplier",
    name: "topsupplier",
    component: resolve => require(["@/components/prize/topsupplier"], resolve)
  },
  {
    path: "/topstore",
    name: "topstore",
    component: resolve => require(["@/components/prize/topstore"], resolve)
  },
  {
    path: "/purchase", //采购节
    name: "purchase",
    component: resolve => require(["@/components/purchase/purchase"], resolve)
  },
  {
    path: "/tianmao", //天猫二手店
    name: "tianmao",
    component: resolve => require(["@/components/tianmao/tianmao"], resolve)
  },
  {
    path: "/tianmao_detail", //天猫二手店
    name: "tianmao_detail",
    component: resolve =>
      require(["@/components/tianmao/tianmao_detail"], resolve)
  },
  {
    path: "/yiqing", //疫情专题
    name: "yiqing",
    component: resolve => require(["@/components/yiqing/yiqing"], resolve)
  },
  {
    path: "/repeatwork", //企业复工
    name: "repeatwork",
    component: resolve => require(["@/components/yiqing/repeatWork"], resolve)
  },
  {
    path: "/findgoods", //发现好货
    name: "findgoods",
    component: resolve =>
      require(["@/components/findgoods/findgoods"], resolve)
  },
  {
    path: "/hotstore", //人气商家
    name: "hotstore",
    component: resolve =>
      require(["@/components/findgoods/hotstore"], resolve)
  },
  {
    path: "/jiafangcheng", //家纺城专题
    name: "jiafangcheng",
    component: resolve =>
      require(["@/components/special/jiafangcheng"], resolve)
  },
  {
    path: "/zhounian", //4周年
    name: "zhounian",
    component: resolve => require(["@/components/special/zhounian"], resolve)
  },
  {
    path: "/channel", //文章频道
    name: "channel",
    component: resolve => require(["@/components/article/channel"], resolve)
  },
  {
    path: "/articlelist", //文章列表
    name: "articlelist",
    component: resolve =>
      require(["@/components/article/articlelist"], resolve)
  },
  {
    path: "/articledetail", //文章详情
    name: "articledetail",
    component: resolve =>
      require(["@/components/article/articledetail"], resolve)
  },
  {
    path: "/zjfrecord", //找家纺大事记
    name: "zjfrecord",
    component: resolve => require(["@/components/special/zjfrecord"], resolve)
  },
  {
    path: "/videolist", //视频列表
    name: "videolist",
    component: resolve => require(["@/components/video/videolist"], resolve)
  },
  {
    path: "/videodetail", //视频详情
    name: "videodetail",
    component: resolve => require(["@/components/video/videodetail"], resolve)
  },
  {
    path: "/xuanpin", //直播选品
    name: "xuanpin",
    component: resolve => require(["@/components/special/xuanpin"], resolve)
  },
  {
    path: "/mayi", //蚂蚁仓
    name: "mayi",
    component: resolve => require(["@/components/special/mayi"], resolve)
  },
  {
    //收藏夹
    path: "/favorites",
    name: "favorites",
    component: resolve => require(["@/components/favorites/index"], resolve)
  },
  {
    path: "*", //
    name: "unfind",
    component: resolve => require(["@/components/default/unfind"], resolve)
  },
  {
    path: "/zhaohuo", //找货助手
    name: "zhaohuo",
    // component: resolve => require(["@/components/special/zhaohuo"], resolve)
    redirect: to => {
      window.location.href = 'https://www.fangzhibao.com'
    }
  },
  {
    path: "/landingPage", //找货助手
    name: "landingPage",
    component: resolve =>
      require(["@/components/special/landingPage"], resolve)
  },
  {
    path: "/antbarn", //蚂蚁仓频道招商
    name: "antbarn",
    component: resolve => require(["@/components/special/antbarn"], resolve)
  },
  {
    path: "/basketball", //篮球赛
    name: "basketball",
    component: resolve =>
      require(["@/components/special/basketball"], resolve)
  },
  {
    path: "/basketballstyle", //篮球赛
    name: "basketballstyle",
    component: resolve =>
      require(["@/components/special/basketballstyle"], resolve)
  },
  {
    path: "/springclose", //春节不打烊
    name: "springclose",
    component: resolve =>
      require(["@/components/special/springclose"], resolve)
  },
  {
    path: "/newyear", //新年活动
    name: "newyear",
    component: resolve =>
      require(["@/components/special/pagesnewyear"], resolve)
  },
  {
    path: "/feedback", // 投诉
    name: "feedback",
    component: resolve => require(["@/components/feedback/index"], resolve)
  },
  {
    path: "/montage", // 红馆拼接广告
    name: "montage",
    component: resolve => require(["@/components/special/montage"], resolve)
  },
  {
    path: "/subsidy", // 男装百亿补贴
    name: "subsidy",
    component: resolve => require(["@/components/special/subsidy"], resolve)
  },
  {
    path: "/subsidy_zl", // 童装百亿补贴
    name: "subsidy_zl",
    component: resolve =>
      require(["@/components/special/subsidy_zl"], resolve)
  },
  {
    path: "/subsidy_csdmnvz", // 女装百亿补贴
    name: "subsidy_csdmnvz",
    component: resolve =>
      require(["@/components/special/subsidy_csdmnvz"], resolve)
  },
  {
    path: "/tongzhuang", // 热卖童装
    name: "tongzhuang",
    component: resolve =>
      require(["@/components/special/tongzhuang"], resolve)
  },
  {
    path: "/touristseason", // 热卖童装
    name: "touristseason",
    component: resolve =>
      require(["@/components/special/touristseason"], resolve)
  },
  {
    path: "/transportnew", // 运费测算
    name: "transportnew",
    component: resolve =>
      require(["@/components/transport/transportnew"], resolve)
  },
  {
    path: "/onlineretailertool", // 新页面onlineretailertool
    name: "onlineretailertool",
    component: resolve => require(["@/components/onlineretailertool/index"], resolve)
  }
];


/** 一个只允许访问找货助手的站点，且剔除品牌信息 */
if(location.host === 'zhaohuo.mqgou.com'){
  try{
    document.title = '找货助手';
  }catch (e){
    //do nothing
  }
  routes = [
    {
      path: '/',
      name: 'root',
      redirect: '/fzb-zhaohuo'
    },
    {
      path: "/fzb-zhaohuo", //找货助手
      name: "zhaohuo",
      component: resolve => require(["@/components/special/zhaohuo-no-brand"], resolve)
    },
  ]
}else{
  function setHead() {
    // ===== 1. title =====
    document.title = '纺支宝服装网-服装批发服装网销货源一件代发_服装批发货源平台上纺支宝'

    // ===== 2. favicon =====
    let iconLink = document.querySelector('#icon-link')
    if (!iconLink) {
      iconLink = document.createElement('link')
      iconLink.id = 'icon-link'
      iconLink.rel = 'icon'
      document.head.appendChild(iconLink)
    }
    iconLink.href = 'https://qiniu.zhaojiafang.com/data/upload/icon/fzb.jpg?_t=' + Date.now()

    // ===== 3. keywords =====
    let keywords = document.querySelector('meta[name="keywords"]')
    if (!keywords) {
      keywords = document.createElement('meta')
      keywords.name = 'keywords'
      document.head.appendChild(keywords)
    }
    keywords.content = '纺支宝服装网,常熟服装网,服装,服装批发,纺支宝服装批发,服装货源,服装一件代发,纺支宝服装货源,纺支宝一件代发,纺支宝常熟服装网'

    // ===== 4. description =====
    let description = document.querySelector('meta[name="description"]')
    if (!description) {
      description = document.createElement('meta')
      description.name = 'description'
      document.head.appendChild(description)
    }
    description.content = '纺支宝（常熟服装网）是专业的服装批发货源及一件代发平台。纺支宝服装网集服装批发、服装网销货源、服装一件代发、服装网店直播货源、服装批发货源等集一体的线上批发营销渠道。为全国电商卖家、网红直播、微商和服装店提供极具性价比的服装批发货源以及方便快捷的一件代发服务。'
  }
  setHead()
}


export default new Router({
  mode: "history",
  base: "/",
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js